import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { StandProfileButton } from 'page/ProfileScreen/StandProfilesPanel/StandProfileButton'
import { store } from 'store/store'

type Props = {
  compact?: boolean
}

export const StandProfilesPanel = observer(({ compact }: Props) => {
  const canAdd = store.identities.profiles.length < 5
  const size = compact ? 64 : 108
  const gap = compact ? 12 : 24

  return <Space gap={gap} wrap>
    {store.identities.profiles.map(it => <StandProfileButton key={it.key} it={it} size={size} />)}
    {canAdd && <StandProfileButton it={undefined} size={size} />}
  </Space>
})
